import { db } from '../db';
import { itemService } from './api';

export const SyncService = {
  pushLocalChanges: async () => {
    if (!navigator.onLine) return;
    const user = await db.user.toCollection().first();
    if (!user || !user.token) return;

    const localItems = await db.items.toArray();
    try {
      await itemService.syncItems(localItems, user.household_id, user.token);
    } catch (error) {
      console.error("Erreur push:", error);
    }
  },

  pullServerChanges: async () => {
    if (!navigator.onLine) return;
    const user = await db.user.toCollection().first();
    if (!user || !user.token) return;

    try {
      const response = await itemService.fetchItems(user.token);
      if (response.ok) {
        const serverItems = await response.json();
        await db.transaction('rw', db.items, async () => {
          await db.items.clear();
          await db.items.bulkAdd(serverItems);
        });
      }
    } catch (error) {
      console.error("Erreur pull:", error);
    }
  }
};